import { ReactElement, ReactNode } from "react";

import { useSession } from "@/hooks/@custom/useSession";

export enum Role {
  Administrador = "Administrador",
  Expedicao = "Expedição",
  Usuario = "Usuario",
  Transportadora = "Transportadora",
  Espectador = "Espectador",
  Portaria = "Portaria"
}

type RoleInfo = {
  role: Role | undefined;
  hasAccess: boolean;
};

type RoleGuardImplProps = {
  allowed?: Role[];
  notAllowed?: Role[];
  fallback?: ReactElement | null;
  children: ReactNode | ((roleInfo: RoleInfo) => ReactNode);
};

function RoleGuardImpl({ allowed, notAllowed, fallback = null, children }: RoleGuardImplProps) {
  const { expedition } = useSession();
  const role = expedition?.role as unknown as Role;

  if (!role) {
    return fallback;
  }

  const isAllowedViolated = allowed && !allowed.includes(role);
  const isNotAllowedViolated = notAllowed && notAllowed.includes(role);
  const hasAccess = !isAllowedViolated && !isNotAllowedViolated;

  if (!hasAccess) {
    return fallback;
  }

  if (typeof children === "function") {
    return <>{children({ role, hasAccess })}</>;
  }

  return <>{children}</>;
}

export const RoleGuard = Object.assign(RoleGuardImpl, {
  Role
});
